export default import.meta.ROLLUP_FILE_URL_$wdcTztPBfhQq_$sybjzlA